<template>
  <div class="content-wrapper">
    <vs-row class="my-2" style="min-height: 120px">
      <vs-col vs-lg="8" vs-sm="12">
        <SummaryTable :stats="stats"></SummaryTable>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <div style="float: right">
          <b-form-input
            id="search"
            class="inputx"
            style="text-transformation: none; width: 300px"
            placeholder="Search..."
            v-bind:value="search"
            v-on:input="debounceInput"
            @keydown.esc="clearSearch()"
          />
          <i
            id="search-cancel"
            class="fas fa-times fa-2x cursor-pointer text-primary"
            @mousedown="clearSearch()"
          >
          </i>
        </div>
      </vs-col>
    </vs-row>

    <vs-row class="mb-2">
      <vs-col vs-type="flex" vs-lg="4" vs-sm="12" class="m-0 p-0"> </vs-col>
      <vs-col vs-align="flex-end" vs-lg="8" vs-sm="12" class="m-0 p-0">
        <div class="text-right lg:inline-block" style="float: right">
          <!-- action table -->
          <ul class="demo-alignment pb-0" style="float: right">
            <li style="margin-right: 0rem">
              <!--
              <b-form-select
                v-model="selectedTypes"
                :options="typeOptions"
                class="mt-1"
                @change="onTypeChanged()"
              />
              -->

              <vs-select
                placeholder="Select Referrer"
                multiple
                class=""
                v-model="selectedRefs"
                style="width: 200px; display: inline-block; margin-right: 8px"
                @change="onTypeChanged()"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in refOptions"
                />
              </vs-select>
              <vs-select
                placeholder="Select Ticket Type"
                multiple
                class=""
                v-model="selectedTypes"
                style="width: 200px; display: inline-block"
                @change="onTypeChanged()"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in typeOptions"
                />
              </vs-select>
            </li>
            <li v-if="showExport" class="pl-4 border-0">
              <i
                class="fas fa-file-download fa-2x cursor-pointer hover:text-primary"
                @click="onExport()"
              ></i>
            </li>
          </ul>
        </div>
      </vs-col>
    </vs-row>

    <vs-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template #empty="scope">
          <div class="text-center">
            <h4><strong>There's nothing here yet.</strong></h4>
          </div>
        </template>

        <template v-slot:cell(status)="data">
          <div v-if="data.item.rsvp_response != null">
            <vs-chip
              style="width: 135px"
              v-if="data.item.rsvp_response == 'transfer'"
              >Transferred</vs-chip
            >
            <vs-chip
              style="width: 135px"
              v-if="data.item.rsvp_response == 'declined'"
              >Declined</vs-chip
            >
          </div>
          <div v-else>
            <vs-chip
              style="width: 135px"
              v-bind:class="
                data.item.order.rowstatus.toLowerCase().replace(' ', '')
              "
              >{{ data.item.order.rowstatus.toUpperCase() }}</vs-chip
            >
          </div>
        </template>

        <template v-slot:cell(type)="data">
          <div style="width: 120px">{{ data.value }}</div>
        </template>

        <template v-slot:cell(order_id)="data">
          <div>
            <b-button @click="openOrder(data.item)" variant="outline-secondary">
              {{ data.value }}
            </b-button>
          </div>
        </template>

        <template v-slot:cell(price)="data">
          <div style="width: 150px">{{ data.value | numFormat("0,0.00") }}</div>
        </template>

        <template v-slot:cell(role)="data">
          <div>
            <div>{{ data.value }}</div>
            <div class="mt-3">
              <a href="javascript:void(0)" @click="editRolePopupOpen(data.item)"
                >{{ (data.value ? "Edit": "Add")}}</a
              >
            </div>
          </div>
        </template>

        <template v-slot:cell(isPanelist)="data">
          <vs-switch
            v-model="data.item.isPanelist"
            @change="onRoleChanged(data.item)"
          />
        </template>

        <template v-slot:cell(email)="data">
          <span @click="onEmailClicked(data.item.email)">{{
            data.item.email
          }}</span>
        </template>

        <template v-slot:cell(join)="data">
          <div style="width: 200px">
            <b-form-select
              v-model="data.item.selectedJoin"
              :options="joinOptions"
              class="mt-1"
              @change="onJoinSelected(data.item)"
            />
            <!--
            <vs-button type="border" class color="grey" size="small"
              >Now</vs-button
            >
            <vs-button type="border" class color="grey" size="small"
              >Start-15min</vs-button
            >
            <vs-button type="border" class color="grey" size="small"
              >Start-10s</vs-button
            >
            <vs-button type="border" class color="grey" size="small"
              >Start+5m</vs-button
            >
            <vs-button type="border" class color="grey" size="small"
              >End+5m</vs-button
            >
            <vs-button type="border" class color="grey" size="small"
              >End+1d</vs-button
            >
            -->
          </div>
        </template>

        <template v-slot:cell(edit)="data">
          <b-button
            @click="openAttendeeInfo(data.item)"
            variant="outline-secondary"
          >
            Edit
          </b-button>
          <!--
          <vs-button type="border" class color="grey"></vs-button>
          -->
        </template>

        <template v-slot:cell(zoom)="data">
          <div style="width: 200px">
            <b-button
              @click="onAction(data.item, 'registerzoom')"
              variant="outline-secondary"
            >
              Register
            </b-button>
          </div>
        </template>

        <template v-slot:cell(resend)="data">
          <!--
            if ($row['trash'] != "y" && $row['duplicate'] != "y" && $row['voided'] != "y" && $row['confirmed'] == "y") {
          -->
          <div style="width: 200px">
            <b-button
              @click="onAction(data.item, 'resendmessage')"
              variant="outline-secondary"
            >
              Resend Ticket
            </b-button>
          </div>
        </template>

        <template v-slot:cell(attendee_messages)="data">
          <b-dropdown text="Send Message" variant="outline-secondary">
            <b-dropdown-item
              @click="onSendAttendeeMessage(data.item.ticket, item)"
              v-for="(item, index) in data.item.attendee_messages"
              :key="index"
              >Send {{ item.button_text }} Email</b-dropdown-item
            >
          </b-dropdown>
        </template>

        <template v-slot:cell(reminders)="data">
          <b-dropdown text="Reminder" variant="outline-secondary">
            <b-dropdown-item
              @click="onSendRemider(data.item, item)"
              v-for="(item, index) in data.item.reminders"
              :key="index"
              >{{ item.title }}</b-dropdown-item
            >
          </b-dropdown>
        </template>

        <template v-slot:cell(referrer)="data">
          <div style="width: 130px">{{ data.value }}</div>
        </template>

        <template v-slot:cell(field_a1)="data">
          <i
            v-if="columns.find(x => x.key == `field_a1`).is_image"
            class="far fa-file-image fa-2x"
            @click="
              showSlip(
                data.value
              )
            "
          ></i>
          <span v-else>{{ data.value }}</span>
        </template>

        <template v-slot:cell(field_a2)="data">
          <i
            v-if="columns.find(x => x.key == `field_a2`).is_image"
            class="far fa-file-image fa-2x"
            @click="
              showSlip(
                data.value
              )
            "
          ></i>
          <span v-else>{{ data.value }}</span>
        </template>

        <template v-slot:cell(field_a3)="data">
          <i
            v-if="columns.find(x => x.key == `field_a3`).is_image"
            class="far fa-file-image fa-2x"
            @click="
              showSlip(
                data.value
              )
            "
          ></i>
          <span v-else>{{ data.value }}</span>
        </template>

        <template v-slot:cell(field_a4)="data">
          <i
            v-if="columns.find(x => x.key == `field_a4`).is_image"
            class="far fa-file-image fa-2x"
            @click="
              showSlip(
                data.value
              )
            "
          ></i>
          <span v-else>{{ data.value }}</span>
        </template>
        <template v-slot:cell(field_a5)="data">
          <i
            v-if="columns.find(x => x.key == `field_a5`).is_image"
            class="far fa-file-image fa-2x"
            @click="
              showSlip(
                data.value
              )
            "
          ></i>
          <span v-else>{{ data.value }}</span>
        </template>
        <template v-slot:cell(field_a6)="data">
          <i
            v-if="columns.find(x => x.key == `field_a6`).is_image"
            class="far fa-file-image fa-2x"
            @click="
              showSlip(
                data.value
              )
            "
          ></i>
          <span v-else>{{ data.value }}</span>
        </template>
        <template v-slot:cell(field_a7)="data">
          <i
            v-if="columns.find(x => x.key == `field_a7`).is_image"
            class="far fa-file-image fa-2x"
            @click="
              showSlip(
                data.value
              )
            "
          ></i>
          <span v-else>{{ data.value }}</span>
        </template>
        <template v-slot:cell(field_a8)="data">
          <i
            v-if="columns.find(x => x.key == `field_a8`).is_image"
            class="far fa-file-image fa-2x"
            @click="
              showSlip(
                data.value
              )
            "
          ></i>
          <span v-else>{{ data.value }}</span>
        </template>
        <template v-slot:cell(field_a9)="data">
          <i
            v-if="columns.find(x => x.key == `field_a9`).is_image"
            class="far fa-file-image fa-2x"
            @click="
              showSlip(
                data.value
              )
            "
          ></i>
          <span v-else>{{ data.value }}</span>
        </template>
        <template v-slot:cell(field_a10)="data">
          <i
            v-if="columns.find(x => x.key == `field_a10`).is_image"
            class="far fa-file-image fa-2x"
            @click="
              showSlip(
                data.value
              )
            "
          ></i>
          <span v-else>{{ data.value }}</span>
        </template>

        <template v-slot:cell(progress)="data">
          <div v-if="data.item.amount != 0 && event && event.fields_status">
            <vs-progress
              :height="12"
              :percent="
                data.item.confirm_date && checkIfAnswerAttendeeInfo(data.item)
                  ? 100
                  : data.item.confirm_date
                  ? 50
                  : data.item.register_date
                  ? 10
                  : 0
              "
              color="primary"
            ></vs-progress>
            <div class="d-flex justify-content-between" style="width:300px">
              <div style="width:82px">
                Register
              </div>
              <div style="width:82px" class="text-center">
                Pay
              </div>
              <div style="width:82px" class="text-right">
                Attendee Info
              </div>
            </div>
          </div>
          <div v-else-if="event && event.fields_status">
            <vs-progress
              :height="12"
              :percent="
                data.item.is_answer_attendee_info
                  ? 100
                  : data.item.register_date
                  ? 10
                  : 0
              "
              color="primary"
            ></vs-progress>
            <div class="d-flex justify-content-between" style="width:300px">
              <div style="width:82px">
                Register
              </div>
              <div style="width:82px" class="text-right">
                Attendee Info
              </div>
            </div>
          </div>
          <div v-else-if="data.item.amount != 0">
            <vs-progress
              :height="12"
              :percent="
                data.item.confirm_date ? 100 : data.item.register_date ? 10 : 0
              "
              color="primary"
            ></vs-progress>
            <div class="d-flex justify-content-between" style="width:300px">
              <div style="width:82px">
                Register
              </div>
              <div style="width:82px" class="text-right">
                Pay
              </div>
            </div>
          </div>
          <div v-else>
            <vs-progress
              :height="12"
              :percent="data.item.register_date ? 100 : 0"
              color="primary"
            ></vs-progress>
            <div class="d-flex justify-content-between" style="width:300px">
              <div style="width:82px"></div>
              <div style="width:82px" class="text-right">
                Register
              </div>
            </div>
          </div>
        </template>

        <template
          v-for="q in attendee_info_question_list"
          v-slot:[`cell(${q.question_uuid})`]="data"
        >
          {{ data.item.attendee_info_form[q.question_uuid].question_answer }}
        </template>

        <template v-slot:cell(request_info)="data">
          <div style="width: 130px">
            <b-button
              v-if="data.item.fieldsfilled_date == null"
              variant="outline-secondary"
            >
              Request Info
            </b-button>
          </div>
        </template>
      </b-table>

      <div class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>

        <div class="mt-3">
          {{ from | numFormat("0,0") }} to {{ to | numFormat("0,0") }} of
          {{ totalRows | numFormat("0,0") }} items
        </div>
      </div>
    </vs-card>
    <!-- <attendee-info-modal
      :attendee="selectedAttendee"
      :showDialog="attendeeInfoDialog"
      @close="attendeeInfoDialog = false"
      @submit="onAttendeeSubmit"
    ></attendee-info-modal> -->

    <TicketEditModal
      :attendee="selectedAttendee"
      :showDialog="attendeeInfoDialog"
      @close="attendeeInfoDialog = false"
      @submit="onAttendeeSubmit"
    ></TicketEditModal>


    <!-- START PAYMENT SLIP POPUP -->
    <vs-popup classContent="popup-example" title="" :active.sync="slipDialog">
      <div class="text-center mb-3">
        <img :src="selectedMedia.url" style="width: 100%" />
      </div>
    </vs-popup>

    <vs-popup title="Edit Role" :active.sync="editRolePopup">
      <div v-if="editRoleItem" class="m-3">
        <div class="d-flex justify-between">
          <h3>{{ editRoleItem.firstName }} {{ editRoleItem.lastName }}</h3>
          <h3>{{ editRoleItem.ticket }}</h3>
        </div>
        <div>
          {{ editRoleItem.email }}
        </div>
        <div class="my-4" style="min-height: 300px;">
          <div>
            <v-select
              v-model="selectedRole"
              :options="roleOptions"
              :searchable="false"
              :clearable="false"
            ></v-select>
          </div>
        </div>
        <vs-divider/>
        <div class="d-flex">
          <div class="ml-auto">
            <vs-button
              @click="saveRolePopup()"
              >Save</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import Service from "@/services";
import XLSX from "xlsx"; // import xlsx
import moment from "moment";
import SummaryTable from "@/components/soldoutt/SummaryTable.vue";
import AttendeeInfoModal from "@/components/soldoutt/AttendeeInfoModal.vue";
import TicketEditModal from "@/components/soldoutt/TicketEditModal.vue";
import { mapState } from "vuex";
import vSelect from "vue-select";

import {
  onlineTicketCols,
  standardTicketCols,
  freeTicketCols,
  pttgcTicketCols
} from "@/utils/columns";

export default {
  components: {
    SummaryTable,
    TicketEditModal,
    vSelect
  },
  data: () => ({
    using_form_event_id: 1406, // prod
    // using_form_event_id: 1419,// test
    attendeeInfoDialog: false,
    slipDialog: false,
    order_id: null,
    selectedAttendee: null,
    isBusy: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    columns: standardTicketCols,
    event: null,
    stats: null,
    joinOptions: [
      { text: "Now", value: "0" },
      { text: "Start-5m", value: "-300" },
      { text: "Start-10s", value: "-10" },
      { text: "Start+5m", value: "+300" },
      { text: "End+5m", value: "e+300" },
      { text: "End+1d", value: "e+86400" }
    ],
    selectedTypes: "",
    selectedRefs: "",
    typeOptions: [],
    refOptions: [],
    isSuperAdmin: false,
    showExport: false,
    attendee_messages: [],
    selectedMedia: {
      url: ""
    },
    attendee_info_question_list: [],
    selectedRole: null,
    roleOptions: [],
    editRolePopup: false,
    editRoleItem: null
  }),
  watch: {
    currentPage: {
      handler: function(val, oldVal) {
        if (oldVal != val) {
        }
      }
    },
    search: {
      handler: function(val, oldVal) {
        if (oldVal != val) {
          this.checkSearchStr(val);
        }
      }
    }
  },
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  beforeMount() {},
  mounted() {
    window.addEventListener("keydown", e => {
      if (this.attendeeInfoDialog == false) {
        if (!e.target.matches('[id="search"]')) {
          //backspace
          if (e.which == 27 || e.which == 8) {
            let s = this.search.substring(0, this.search.length - 1);
            this.search = s;
          } else if (
            e.ctrlKey ||
            e.altKey ||
            e.shiftKey ||
            e.which == 9 ||
            e.which == 91 ||
            (e.which >= 112 && e.which <= 123)
          ) {
          } else {
            this.search += String.fromCharCode(e.keyCode);
          }
          return;
        }
      }
    });
  },
  created() {
    this.order_id = this.$route.query.o;

    Service.Event.get(this.$route.query.e)
      .then(res => {
        if (res.success) {
          let data = {
            merchant_id: res.data.event.merchant_id,
            biz: "ev",
            x: res.data.event.event_id
          };

          let header = {
            slug: res.data.event.e,
            title: res.data.event.pro_name,
            excerpt: res.data.event.date,
            image: res.data.event.merchant.logo,
            action: "openEventList"
          };

          this.event = res.data.event;


          if(this.event.ticket_role){
            const jsonRole = JSON.parse(this.event.ticket_role);
            const roles = Object.keys(jsonRole);
            this.roleOptions = [
              "No Role",
              ...roles
            ];
          }
          if (this.event.e == "symposium") {
            this.columns = pttgcTicketCols;
          } else if (this.event.mode == "online") {
            this.columns = onlineTicketCols;
          } else if (this.event.freeevent == 1) {
            this.columns = freeTicketCols;
          }

          this.$store.dispatch("Utility/setHeader", header);

          Service.Order.summary(data).then(r => {
            this.stats = r.data;
          });
        }
      })
      .catch(e => {
        console.log(e)
        /* this.$router.push("/pages/error-404").catch(() => {}); */
      });
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
      //this.$refs.table.refresh();
    }, 500),
    checkSearchStr: _.debounce(function(val) {
      this.filter = val;
      this.$refs.table.refresh();
    }, 500),
    dataProvider(ctx, callback, perPage = 15) {
      this.isBusy = true;

      setTimeout(() => {
        let data = {
          e: this.$route.query.e,
          view: this.selectedTypes,
          referer: this.selectedRefs,
          perPage: perPage
        };

        if (this.order_id != null) {
          data.o = this.order_id;
        }

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map(key => key + "=" + ctx[key])
            .join("&");

        const insert = (arr, index, newItem) => [
          // part of the array before the specified index
          ...arr.slice(0, index),
          // inserted item
          newItem,
          // part of the array after the specified index
          ...arr.slice(index)
        ];

        Service.Ticket.getListWithAttendeeInfoForm(params)
          .then(res => {
            Service.AttendeeMessage.gets(
              "e=" + res.data.event.e + "&listing_status=1"
            ).then(messages => {
              this.attendee_messages = messages.data.list;

              this.isBusy = false;
              this.totalRows = res.data.total;
              this.from = res.data.from;
              this.to = res.data.to;
              this.data = res.data.rows.map(item => {
                let isPanelist = false;
                if (item.role == "panelist") {
                  isPanelist = true;
                }

                return {
                  ...item,
                  selectedJoin: null,
                  attendee_messages: this.attendee_messages,
                  isPanelist: isPanelist,
                  reminders: [
                    {
                      subject: "Starting Soon",
                      title: "Starting Soon",
                      ticket: item.ticket,
                      lang: "en"
                    },
                    {
                      subject: "Happening Tomorrow",
                      title: "Happening Tomorrow",
                      ticket: item.ticket,
                      lang: "en"
                    }
                  ]
                };
              });

              this.showExport = res.data.export;

              if (res.data.role == "so-admin") {
                this.isSuperAdmin = true;
              }

              if (res.data.rows.length < this.perPage) {
                this.to = res.data.total;
              }

              let afterDisbledIndex = this.columns.findIndex(
                x => x.key == "disabled"
              );

              if (
                this.event &&
                this.event.event_id == this.using_form_event_id
              ) {
                Service.Question.getAttendeeInfoForm(params).then(
                  attendeeInfoRes => {
                    const original_questions = JSON.parse(
                      JSON.stringify(attendeeInfoRes.data.questions)
                    );
                    attendeeInfoRes.data.questions = attendeeInfoRes.data.questions.map(
                      (q, index) => {
                        let count = 0;
                        for (let i = 0; i < index; i++) {
                          if (
                            original_questions[i].question_title ==
                            q.question_title
                          ) {
                            count++;
                          }
                        }
                        if (count > 0) {
                          q.question_title =
                            q.question_title + " (" + (count + 1) + ")";
                        }
                        return q;
                      }
                    );
                    this.attendee_info_question_list =
                      attendeeInfoRes.data.questions;
                    for (
                      let i = 0;
                      i < attendeeInfoRes.data.questions.length;
                      i++
                    ) {
                      console.log(
                        attendeeInfoRes.data.questions[i].weight,
                        attendeeInfoRes.data.questions[i]
                      );
                      this.columns = insert(
                        this.columns,
                        afterDisbledIndex + 1 + i,
                        {
                          label:
                            attendeeInfoRes.data.questions[i].question_title,
                          key: attendeeInfoRes.data.questions[i].question_uuid,
                          type: attendeeInfoRes.data.questions[i].question_uuid,
                          sortable: false,
                          adminOnly: false
                        }
                      );
                    }
                  }
                );
              } else {
                [
                  /* attendee Info */
                  1,
                  2,
                  3,
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10
                ].map(key => {
                  // console.log('key',key)
                  let is_image = false;
                  if (res.data.event["field_type" + key] == "uploadimage") {
                    is_image = true;
                  }
                  // console.log('field_status',key,res.data.event["field_status" + key])
                  if (res.data.event["field_q" + key]) {
                    this.columns = insert(this.columns, afterDisbledIndex + 1, {
                      label: res.data.event["field_q" + key],
                      key: "field_a" + key,
                      type: res.data.event["field_type" + key],
                      sortable: true,
                      adminOnly: false,
                      is_image: is_image
                    });
                  }
                });
              }

              if (!this.isSuperAdmin) {
                this.columns = this.columns.filter(x => x.adminOnly == false);
              }

              this.typeOptions = res.data.types.map(item => {
                return { text: item.pro_title, value: item.product_id };
              });

              this.refOptions = res.data.referers.map(item => {
                return { text: item.ref, value: item.ref };
              });

              this.log = res.log;
              this.lagacy_query = res.lagacy_query;

              callback(this.data);
            });
          })
          .catch(error => {
            callback([]);
          });

        return null;
      }, 500);
    },
    exportDataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map(key => key + "=" + ctx[key])
            .join("&");

        return Service.Report.ticket(params)
          .then(res => {
            this.data = res.data.map(item => {
              let qty = item.Quanity;

              let issue_percent = (item.Tickets / qty) * 100;
              if (issue_percent < 1) {
                issue_percent = Math.ceil(issue_percent);
              } else {
                issue_percent = Math.floor(issue_percent);
              }

              let progress = issue_percent;
              let remaining = qty - item.Tickets;
              if (qty == null) {
                remaining = "";
              }

              return {
                ...item,
                issue_percent: issue_percent,
                remaining: remaining,
                progress: progress,
                qty: qty
              };
            });

            let footerRow = res.data[res.data.length - 1];
            for (var key in footerRow) {
              if (footerRow.hasOwnProperty(key)) {
                let index = this.columns.findIndex(x => x.key == key);
                if (index >= 0) {
                  this.columns[index].foot = footerRow[key];
                }
              }
            }
            this.data.pop();
            callback(this.data);
          })
          .catch(error => {
            callback([]);
          });
      }, 500);
    },
    editRolePopupOpen(item) {
      this.editRoleItem = item;
      this.selectedRole = !item.role? "No Role": item.role;
      this.editRolePopup = true;
    },
    saveRolePopup() {
      let data = {
        ticket: this.editRoleItem.ticket,
        role: this.selectedRole == "No Role" ? null: this.selectedRole,
        s: this.s,
        e: this.e
      };
      this.$vs.loading();
      Service.Ticket.update(data).then(res => {
        this.$vs.loading.close();
        this.editRolePopup = false;
        this.editRoleItem.role = this.selectedRole == "No Role" ? null: this.selectedRole;
      }).catch(()=>{
        this.editRolePopup = false;
      });

    },
    checkIfAnswerAttendeeInfo(ticket) {
      if (this.event.event_id == this.using_form_event_id) {
        return ticket.is_answer_attendee_info;
      } else {
        return !!(
          ticket.field_a1 ||
          ticket.field_a2 ||
          ticket.field_a3 ||
          ticket.field_a4 ||
          ticket.field_a5 ||
          ticket.field_a6 ||
          ticket.field_a7 ||
          ticket.field_a8 ||
          ticket.field_a9
        );
      }
    },
    showSlip(data) {
      this.selectedMedia.url = data;
      this.slipDialog = true;
    },
    onRoleChanged(item) {
      let role = "panelist";
      if (item.role == "panelist") {
        role = null;
      }

      Service.Ticket.update({ role: role, ticket: item.ticket, s: this.s,  e: this.e }).then(res => {
        this.$refs.table.refresh();
      });
    },
    openOrder(item) {
      this.$router.push(
        "/orders?s=" +
          this.$route.query.s +
          "&e=" +
          this.$route.query.e +
          "&o=" +
          item.order_id
      );
    },
    async onExport() {
      let rows = [];
      let days = [];
      let header = [];

      header = [
        "ID",
        "Ticket",
        "Quota",
        "Issued",
        "Confirmed",
        "Waitlisted",
        "Checked-in",
        "Remaining",
        "Progress"
      ].map(item => {
        return { text: item };
      });

      this.$vs.loading();
      try {
        let data = {
          e: this.$route.query.e,
          view: this.selectedTypes,
          referer: this.selectedRefs,
          perPage: 10000
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");
        let questions = [];
        if (this.event && this.event.event_id == this.using_form_event_id) {
          const questionsRes = await Service.Question.getAttendeeInfoForm(
            params
          );
          questions =
            questionsRes && questionsRes.data && questionsRes.data.questions
              ? questionsRes.data.questions
              : [];
          const original_questions = JSON.parse(JSON.stringify(questions));
          questions = questions.map((q, index) => {
            let count = 0;
            for (let i = 0; i < index; i++) {
              if (original_questions[i].question_title == q.question_title) {
                count++;
              }
            }
            if (count > 0) {
              q.question_title = q.question_title + " (" + (count + 1) + ")";
            }
            return q;
          });
        }
        this.dataProvider(
          {},
          rows => {
            const rowsData = rows.map(item => {
              const rowdata = {};
              for (let i = 0; i < this.columns.length; i++) {
                if (
                  ![
                    "",
                    "attendee_messages",
                    "edit",
                    "resend",
                    "attendee_messages",
                    "reminders",
                    "zoom",
                    "request_info",
                    "info",
                    "send_invitation"
                  ].includes(this.columns[i].key)
                ) {
                  let colkey = this.columns[i].key;
                  let colval = item[colkey];

                  if (colkey == "status") {
                    if (item.rsvp_response) {
                      if (item.rsvp_response == "transfer") {
                        colval = "Transferred";
                      } else if (item.rsvp_response == "declined") {
                        colval = "Declined";
                      }
                    } else {
                      colval = item.order.rowstatus.toUpperCase();
                    }
                  }

                  rowdata[this.columns[i].label] = colval;
                }
              }
              if (
                rowdata &&
                this.event &&
                this.event.event_id == this.using_form_event_id
              ) {
                for (let i = 0; i < questions.length; i++) {
                  rowdata[questions[i].question_title] =
                    item.attendee_info_form[
                      questions[i].question_uuid
                    ].question_answer;
                }
              }
              // console.log("rowdata", rowdata);
              return rowdata;
            });
            const dataWS = XLSX.utils.json_to_sheet(rowsData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, dataWS);
            XLSX.writeFile(wb, "ticket_report.xlsx");
            this.$vs.loading.close();
          },
          9999
        );
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    async onExportAPI() {
      let rows = [];
      let days = [];

      let header = this.columns.map((item, index) => {
        return { text: item.label };
      });

      this.$vs.loading();
      let data = {
        e: this.$route.query.e,
        view: this.selectedTypes,
        referer: this.selectedRefs,
        perPage: 10000
      };

      if (this.order_id != null) {
        data.o = this.order_id;
      }

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");
      let questions = [];
      if (this.event && this.event.event_id == this.using_form_event_id) {
        const questionsRes = await Service.Question.getAttendeeInfoForm(params);
        questions =
          questionsRes && questionsRes.data && questionsRes.data.questions
            ? questionsRes.data.questions
            : [];
      }
      Service.Ticket.getListWithAttendeeInfoForm(params).then(async res => {
        rows = res.data.rows.map(async (item, index) => {
          let Status = "";
          if (item.rsvp_response != null) {
            if (item.rsvp_response == "transfer") {
              Status = "Transferred";
            } else if (item.rsvp_response == "declined") {
              Status = "Declined";
            }
          } else {
            Status = item.order.rowstatus.toUpperCase();
          }
          // let obj1 = {
          //   Status: Status,
          //   ID: item.ticket_id,
          //   "Booking Code": item.ticket,
          //   Name: item.firstName + " " + item.lastName,
          //   Phone: item.phone,
          //   Email: item.email,
          //   Qty: item.qty,
          //   "Transferred To": item.transfer_to_data,
          //   "Confirm Date": item.confirm_date,
          //   "Register Date": item.register_date,
          //   Confirmed: item.confirmed,
          //   Remark: item.rematk,
          //   Country: item.Country,
          //   "Focal Point": item.referrer,
          //   "Invited By": item.invite_by,

          //   // "Alt Ticket": item.ticket_alt,
          //   // "Registration ID": item.order_id,
          //   // RSVP: item.rsvp,
          //   // Assign: item.assign_date,
          //   // "Check-in": item.checkin,
          //   // Disabled: item.disabled,
          //   // "Promo Code": item.pc,
          //   // "Invite Code": item.invite_code,
          //   // Message: item.message,
          //   // Language: item.language,
          //   // "Last Update": item.last_update_date
          // };
          let obj1 = {
            Status: Status,
            ID: item.ticket_id,
            FirstName: item.firstName,
            LastName: item.lastName,
            Phone: item.phone,
            Email: item.email,
            Type: item.type,
            // Role: item.role,
            // Price: item.price,
            Ticket: item.ticket,
            "Alt Ticket": item.ticket_alt,
            "Registration ID": item.order_id,
            "Transferred To": item.transfer_to_data,
            RSVP: item.rsvp,
            // Assign: item.assign_date,
            Confirm: item.confirm_date,
            "Check-in": item.checkin,
            // Consent: item.consent_status,
            // Disabled: item.disabled,
            // "Promo Code": item.pc,
            "Focal Point": item.referrer,
            // "Invite Code": item.invite_code,
            "Invited By": item.invite_by,
            // Message: item.message,
            Language: item.language,
            Remark: item.remark,
            "Last Update": item.last_update_date
          };

          let infos = {};
          if (this.event && this.event.event_id == this.using_form_event_id) {
            for (let i = 0; i < questions.length; i++) {
              infos[questions[i].question_title] =
                item.attendee_info_form[
                  questions[i].question_uuid
                ].question_answer;
            }
          } else {
            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(key => {
              if (this.event["field_q" + key]) {
                infos[this.event["field_q" + key]] = item["field_a" + key];
              }
            });
          }
          console.log("infos", infos);

          // let afterDisbledIndex = obj1.findIndex((x) => x.key == "Disabled");

          // obj1 = insert(obj1, afterDisbledIndex + 1, {
          //   ...infos,
          // });

          return {
            ...obj1,
            ...infos
          };
        });

        let dataExport = {};
        const dataWS = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(wb, "ticket_export.xlsx");
        this.$vs.loading.close();
      });
    },
    openAttendeeInfo(item) {
      this.selectedAttendee = item;
      this.attendeeInfoDialog = true;
    },
    onEmailClicked(value) {
      this.search = value;
      this.filter = value;
      this.$refs.table.refresh();
    },
    onAttendeeSubmit() {
      this.$refs.table.refresh();
      this.attendeeInfoDialog = false;
    },
    onSendRemider(ticket, item) {
      // console.log(ticket);
      // console.log(item);
      // console.log(this.event);

      let data = {
        action: "reminderticket",
        event_id: this.event.event_id,
        merchant_id: this.event.merchant.merchamt_id,
        lang: "en",
        requested_by: "admin",
        tos: [
          {
            mail: ticket.email,
            fullname: ticket.firstName + " " + ticket.lastName,
            bcc: [],
            sender: {
              name: this.event.merchant.name,
              address: "ticket@soldoutt.com",
              reply_to: "help@soldoutt.com"
            },
            data: {
              subject: item.subject + ": " + this.event.pro_title,
              firstname: ticket.firstName,
              lastname: ticket.lastName,
              product_name: "Test by soldoutt",
              product_shortname: "Test by soldoutt",
              poster: this.event.poster,
              url: null,
              shorturl: "go.soldoutt.com",
              ticket: ticket.ticket,
              deadline: null,
              merchant_name: this.event.merchant.name,
              merchant_logo: this.event.merchant.logo,
              event_date: null,
              event_datetime_c: null,
              event_time: null,
              event_venue: null,
              mode: null,
              price: null,
              currency: null,
              ticket_type: null,
              ticket_note: null,
              ticketcode: null,
              quantity: 1,
              instruction: null,
              fbshareurl: null,
              lineid: null,
              lineaddurl: null,
              supportno: null,
              fbuser: null,
              hidesoldoutt: null
            }
          }
        ]
      };
      // console.log(data);
      Service.Communication.send_email(data).then(res => {
        this.$vs.notify({
          title: "Success",
          text: "Remind Email sent.",
          color: "success"
        });
      });
    },
    onSendAttendeeMessage(ticket, item) {
      let data = {
        tickets: ticket,
        message_id: item.message_id,
        e: this.event.slug
      };

      this.$vs.loading();
      Service.AttendeeMessage.send(data).then(res => {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Success",
          text: "Attendee Massage sent.",
          color: "success"
        });
      });
    },
    onAction(ticket, action, additionalData = null) {
      let callApi = true;
      // console.log(ticket);
      // console.log(action);

      if (callApi) {
        this.$vs.loading();
        let data = {
          e: this.$route.query.e,
          ticket: ticket.ticket,
          action: action,
          remark: ""
        };

        Service.Ticket.action(data)
          .then(res => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Success",
              text: "Action complete.",
              color: "success"
            });
          })
          .catch(err => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Oops!",
              text: "ERROR : " + err.error,
              color: "danger"
            });
          });
      }
    },
    onJoinSelected(item) {
      let second = 0;
      let type = "start";
      if (item.selectedJoin == "-300") {
        second = -300;
      }
      if (item.selectedJoin == "-10") {
        second = -10;
      }
      if (item.selectedJoin == "+300") {
        second = +300;
      }
      if (item.selectedJoin == "e+300") {
        second = +300;
        type = "end";
      }
      if (item.selectedJoin == "e+86400") {
        second = +86400;
        type = "end";
      }
      let tt = null;
      if (type == "start") {
        tt = moment(this.event.datetime).add(second, "seconds");
      } else {
        tt = moment(this.event.datetime_end).add(second, "seconds");
      }
      // console.log(tt.format("YYYY-MM-DD HH:mm:ss"));
      // console.log(item);
      let url =
        "https://" +
        this.event.merchant.domain +
        "/" +
        this.event.e +
        "/join?token=" +
        item.token +
        "&bpt=1&tt=" +
        tt.format("YYYY-MM-DD%20HH:mm:ss");
      window.open(
        url,
        "_blank" // <- This is what makes it open in a new window.
      );
    },
    onTypeChanged() {
      //console.log(this.selectedTypes);
      if (this.selectedTypes == null) {
        this.selectedTypes = "";
      }
      this.$refs.table.refresh();
    }
  }
};
</script>
<style lang="scss">
input#search:focus {
  position: absolute;
  left: 15px;
  top: 130px;
  width: calc(100% - 30px) !important;
  height: 70px;
}

#search-cancel {
  position: fixed;
  right: -50px;
  top: 150px;
}

input#search:focus ~ #search-cancel {
  position: absolute;
  right: 40px;
  top: 150px;
  z-index: 2;
}

input#search {
  transition: all ease 0.3s;
}
.confirmed {
  background-color: #38a169;
  color: #fff !important;
  font-weight: bolder;
}

.needaction {
  background: linear-gradient(-120deg, #ff0813 0%, #c80816 100%);
}

.pending,
.awaitingpayment {
  background-color: #337ab7;
  color: #fff !important;
}

.processing {
  background-color: #d9edf7;
  color: #337ab7 !important;
}

.trash,
.duplicate,
.expired {
  background-color: #ddd;
  color: #999 !important;
  font-weight: bolder;
}

.void {
  background-color: #ddd;
  color: #444 !important;
  font-weight: bolder;
}
</style>
